import { render, staticRenderFns } from "./GenerateAppointmentForm.vue?vue&type=template&id=e95756de&"
import script from "./GenerateAppointmentForm.vue?vue&type=script&lang=js&"
export * from "./GenerateAppointmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports